import { Commission, CommissionStatusEnum, Referral } from '../../lib/models/crm/types';

export enum ReferralsTabEnum {
  referrals = 0,
  commissions = 1,
}

export enum PayoutRequestStateEnum {
  closed = 'CLOSED',
  confirm = 'CONFIRM',
  submitted = 'SUBMITTED',
  failed = 'FAILED',
}

export enum PayoutModalIconEnum {
  error = 'ERROR',
  success = 'SUCCESS',
  wallet = 'WALLET',
}

export enum SocialNetworkEnum {
  facebook = 'FACEBOOK',
  x = 'X',
  linkedin = 'LINKEDIN',
  whatsapp = 'WHATSAPP',
}

export type ReferralGroup = {
  registeredAt: string;
  items: Referral[];
};

export type CommissionGroup = {
  statusChangedAt: string;
  status: CommissionStatusEnum;
  items: Commission[];
};
